import { yupResolver } from "@hookform/resolvers/yup";
import { StartStockCountFormValues } from "./types";
import { schema } from "./constants";
import { FormProvider, useForm } from "react-hook-form";
import { defaultFormValues as cD } from "./constants";
export interface StartStockCountFormProviderProps {
  defaultFormValues?: Partial<StartStockCountFormValues>;
  children?: React.ReactNode;
}

export const StartStockCountFormProvider = ({
  defaultFormValues,
  children,
}: StartStockCountFormProviderProps) => {
  const methods = useForm<StartStockCountFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      ...cD,
      ...defaultFormValues,
    },
    resolver: yupResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
